import immstruct from 'immstruct';

const structure = {
  config: {},
  data: {
    notifications: {}, // push notifications for mobile devices
  },
  auth: {
    user: null,
    initialUrl: null,
  },
  ui: {
    share: null,
    pushNotification: {
      notification: {},
    },
    marker: null,
    error: {},
    infoPanel: {
      isVisible: false,
      component: '',
      props: {},
    },
    search: {
      sidebarOpen: false,
    },
    settings: {
      hd: false,
      baseUrl: '',
      api: {
        baseUrl: '',
      },
    },
    embedModal: {
      open: false,
    },
    datePicker: {
      open: false,
    },
    prompt: {},
    video: {
      isPlaying: false,
      isSeeking: false,
      isFullScreen: false,
      playRequested: false,
      hasPlayed: false,
      audioOnly: false,
      controlsVisible: false,
    },
    about: {
      build: '',
    },
    sync: {
      pdt: null,
    },
    isEmbedded: false,
    seekEvent: null,
    entryParams: null,
    width: document.body.offsetWidth,
  },
};

export default immstruct(structure);
